import React from 'react';

export const getHandlerKayPress = (key: string, cb: () => void) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === key) {
      cb();
    }
  };
};
